import React from 'react';

export const CouponDiscount = ({discount}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="75" height="65" viewBox="0 0 75.734 64.289">
            <g>
                <path d="M454.739,680.738a15.569,15.569,0,0,0,8.037-2.812,16.15,16.15,0,0,1,18.329,0,15.582,15.582,0,0,0,8.037,2.812c6.918.467,12.407,5.1,12.96,10.949a11.027,11.027,0,0,0,3.329,6.789,10.565,10.565,0,0,1,0,15.484,11.036,11.036,0,0,0-3.329,6.789c-.553,5.844-6.042,10.481-12.96,10.949a15.583,15.583,0,0,0-8.037,2.812,16.15,16.15,0,0,1-18.329,0,15.57,15.57,0,0,0-8.037-2.812c-6.918-.468-12.407-5.1-12.96-10.949a11.036,11.036,0,0,0-3.329-6.789,10.565,10.565,0,0,1,0-15.484,11.027,11.027,0,0,0,3.329-6.789C442.332,685.842,447.821,681.205,454.739,680.738Z" transform="translate(-434.074 -674.074)" fill="#fff" stroke="var(--primary)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <text x="13" y="39" fontSize="20" fill="red" fontWeight="bold" fontFamily="Inter">-{discount}%</text>
            </g>
        </svg>
    );
};
